// src/admin/ui/Table.jsx
import React from "react";

export function Table({ columns = [], rows = [], onRowClick }) {
  const isClickable = typeof onRowClick === "function";

  return (
    <div className="table">
      {/* Header */}
      <div className="table__head">
        {columns.map((c) => (
          <div
            key={c.key}
            className="table__th"
            style={{ width: c.width || "auto" }}
          >
            {c.header}
          </div>
        ))}
      </div>

      {/* Body */}
      <div className="table__body">
        {rows.map((r) => {
          const key = r.__key ?? r.id ?? JSON.stringify(r);

          const handleRowClick = () => {
            if (!isClickable) return;
            onRowClick(r);
          };

          const handleKeyDown = (e) => {
            if (!isClickable) return;
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onRowClick(r);
            }
          };

          return (
            <div
              key={key}
              className={`table__row ${isClickable ? "table__row--click" : ""}`}
              role={isClickable ? "button" : undefined}
              tabIndex={isClickable ? 0 : undefined}
              onClick={handleRowClick}
              onKeyDown={handleKeyDown}
            >
              {columns.map((c) => (
                <div
                  key={c.key}
                  className="table__td"
                  style={{ width: c.width || "auto" }}
                >
                  {typeof c.cell === "function" ? c.cell(r) : r[c.key]}
                </div>
              ))}
            </div>
          );
        })}

        {!rows.length && (
          <div className="muted" style={{ padding: 12 }}>
            No rows.
          </div>
        )}
      </div>
    </div>
  );
}